import GameTicker from "@/libs/GameTicker";

let ticker: GameTicker | null = null;

const useGameTicker = (
	...options: ConstructorParameters<typeof GameTicker>
): GameTicker => (!ticker ? (ticker = new GameTicker(...options)) : ticker);

export default useGameTicker;
